const NotFound: React.FC = () => {
  return <p>Page Not Found</p>;
};

export default NotFound;
